// import { GIPHY_API_KEY } from '../constants'
import axios from 'axios'


export const GIPHY_API_KEY = 'ZkvGGrr1qkfOArNoSyww2fL0iBe51R0d'

const limit = 30
const offset = 0
const lang = 'en'

export const getTrendingGif = async () => {
  const trendingURL = `https://api.giphy.com/v1/gifs/trending?api_key=${GIPHY_API_KEY}&limit=${limit}&rating=g`
  const response = await axios.get(trendingURL)
  const data = response.data?.data
  if (Array.isArray(data)) {
    const result = data.map(image => {
      const id = image?.id
      const url = image?.images?.downsized?.url
      return { id, url }
    })
    return result
  }
  return data
}

export const getGifs = async keyword => {
  const searchURL = `https://api.giphy.com/v1/gifs/search?api_key=${GIPHY_API_KEY}&q=${keyword}&limit=${limit}&offset=${offset}&rating=g&lang=${lang}`
  const response = await axios.get(searchURL)
  const data = response.data.data
  if (Array.isArray(data)) {
    const result = data.map(image => {
      const id = image?.id
      const url = image?.images?.downsized?.url
      return { id, url }
    })
    return result
  }
  return data
}

export const getGifById = gifId =>
  new Promise((resolve, reject) => {
    const getByIdURL = `https://api.giphy.com/v1/gifs/${gifId}?api_key=${GIPHY_API_KEY}`
    axios
      .get(getByIdURL)
      .then(response => {
        const data = response?.data?.data
        const id = data.id
        const url = data.images?.downsized?.url
        const result = { id, url }
        resolve(result)
      })
      .catch(e => reject(e))
  })
